export const VERTICAL_SCROLL_WIDTH = 6;
export const FOOTER_HEIGHT = 50;
